export default __webpack_public_path__ + "static/media/pseudo-mask.23235e19.svg";